import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { ThumbtackPro, Advertisement, Provider } from '../../api/adserver';
import { AdvertCategory } from '../../store/advertCategoriesSlice';

export interface SearchBarProps {
  placeholder?: string;
  style?: StyleProp<TextStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  inputContainerStyle?: StyleProp<ViewStyle>;
  enableBack?: boolean;
  initialValue?: string;
  setProvider?: React.Dispatch<React.SetStateAction<Provider>>;
  onBackPressed?: () => void;
  onSearchSubmit?: (value: string) => void;
  onThumbtackSearchSubmit?: React.Dispatch<
    React.SetStateAction<ThumbtackPro[]>
  >;
  onInputUpdate?: (value: string) => void;
  isRendering?: (value: boolean) => void;
  resultsList?: SearchResultCollection;
  onResultPress?: (item: SearchResult) => void;
  sourceCategories?: AdvertCategory[];
  sourceAdvertsList?: Advertisement[];
  onHasResults?: (hasResults: boolean) => void;
  provider?: Provider;
  setSearchText?: React.Dispatch<React.SetStateAction<string | undefined>>;
  onFocus?: () => Promise<void>;
  isApartmentSearch?: boolean;
  setIsApartmentSearch?: React.Dispatch<React.SetStateAction<boolean>>;
}

export enum SearchItemType {
  category = 'category',
  advert = 'advert',
  divider = 'divider',
  noMatches = 'noMatches',
}

export type SearchResult = {
  id: string;
  title: string;
  itemType: SearchItemType;
  subTitle?: string;
};

export type SearchResultCollection = {
  categories: SearchResult[];
  adverts: SearchResult[];
  noMatches: boolean; // there was a search, but there were not matches
};
